module.exports = __webpack_public_path__ + "img/communication.9dda000f.png";